module.exports = __webpack_public_path__ + "img/appltCourse-img13.228c4e98.png";